import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const XmlFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "XmlFile",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.53 10.56a2 2 0 0 0-.12-.35s-.05-.08-.05-.08c-.06-.11-.13-.21-.22-.3l-7.48-7.49c-.09-.09-.19-.16-.3-.22s-.08 0-.08 0c-.08-.04-.17-.08-.26-.1h-9.71c-2.3 0-4.17 1.85-4.21 4.15v7.95H4.29c-1.03 0-1.87.84-1.87 1.87v6.55c0 1.03.84 1.87 1.87 1.87H7.1v1.87c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.81c0-.08 0-.16-.02-.24ZM8.94 21.82c.03.06.05.14.05.21 0 .19-.11.36-.27.44-.06.03-.14.05-.21.05-.19 0-.36-.11-.44-.27L7.1 20.3l-.97 1.95c-.08.16-.24.27-.42.27H5.7c-.08 0-.15-.02-.22-.05a.5.5 0 0 1-.22-.41c0-.09.02-.17.07-.25s1.27-2.58 1.27-2.58l-1.27-2.59a.49.49 0 1 1 .87-.44s.97 1.95.97 1.95l.97-1.95a.49.49 0 0 1 .88.44s-1.33 2.62-1.33 2.62l1.28 2.55Zm17.82 4.41c0 .77-.76.97-1.4.97H11.33c-.64 0-1.4-.17-1.4-.97v-1.84h11.22c1.03 0 1.87-.84 1.87-1.87v-6.55c0-1.03-.84-1.87-1.87-1.87H9.93V6.15c0-.77.63-1.4 1.4-1.4h7.95v5.14c0 1.29 1.05 2.34 2.34 2.34h5.14zm-13.59-6.64c-.08.17-.24.29-.44.29s-.36-.12-.44-.29l-.46-.98v3.43a.49.49 0 0 1-.98 0v-5.58s-.01-.07-.01-.1a.501.501 0 0 1 .99-.11s.97 1.95.97 1.95l.97-1.95c.05-.23.25-.4.49-.4.27 0 .5.22.5.5 0 .04 0 .07-.01.11s0 5.6 0 5.6a.49.49 0 0 1-.98 0v-3.43l-.61.95Zm6.55 1.95a.49.49 0 0 1 0 .98h-2.76a.49.49 0 0 1-.49-.49v-5.56a.49.49 0 0 1 .98 0v5.11z"
    })
  }));
};